import React from 'react';

interface RingProps {
  children: React.ReactNode;
  className?: string;
}

export default function Ring({ children, className = "" }: RingProps) {
  return (
    <div className={`font-sans border border-black rounded-lg bg-white box-border ${className}`}>
      {children}
    </div>
  );
}
